import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const ReportViewAsUsersApi = {
  get: async function (reportId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-view-as-users/' + reportId,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(ReportViewAsUsersApi)

export default ReportViewAsUsersApi
